import gql from 'graphql-tag';

export const DELETE_COMMENT_MUTATION = gql`
  mutation DeleteComment($commentId: String!) {
    deletePostComment(id: $commentId) {
      id
      deleted
    }
  }
`;

export { useDeleteCommentMutation } from '../gen/types';
